import { useSelector } from 'react-redux';

import { getDealXgId } from '../store/config';
import DigitalDealJacket from './DigitalDealJacket';

const ManageDocuments = () => {
    const dealXgId = useSelector(getDealXgId);

    return <DigitalDealJacket externalId={dealXgId} />;
};

export default ManageDocuments;
